// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumOutlinedSvg from "@fishx/icons-svg/es/asn/MediumOutlined";
import FishxIcon from '../components/FishxIcon';

var MediumOutlined = function MediumOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumOutlinedSvg
  }));
};

MediumOutlined.displayName = 'MediumOutlined';
export default React.forwardRef(MediumOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MediumOutlined.js
// module id = 3099
// module chunks = 0